/**
 * BaseStoreSyncManager - Manages pending baseStore synchronization
 * Prevents race conditions when baseStore changes across tabs or requests
 */

let pendingBaseStoreSync = null;

export const getBaseStoreSyncPromise = () => pendingBaseStoreSync;

export const setBaseStoreSyncPromise = (promise) => {
  pendingBaseStoreSync = promise;
};

export const clearBaseStoreSyncPromise = () => {
  pendingBaseStoreSync = null;
};

/**
 * Wrap a baseStore sync operation to track it globally
 * @param {Promise} syncPromise - The sync operation promise
 * @param {number} timeoutMs - Timeout in milliseconds (default 10000ms)
 * @returns {Promise} - The wrapped promise
 */
export const trackBaseStoreSync = (syncPromise, timeoutMs = 10000) => {
  // Create a promise that resolves/rejects with timeout
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error(`BaseStore sync timeout after ${timeoutMs}ms`));
    }, timeoutMs);
  });

  const wrappedPromise = Promise.race([syncPromise, timeoutPromise]);
  
  // Set as pending
  setBaseStoreSyncPromise(wrappedPromise);
  
  // Auto-clear when done
  wrappedPromise.finally(() => {
    clearBaseStoreSyncPromise();
  });

  return wrappedPromise;
};

export default {
  getBaseStoreSyncPromise,
  setBaseStoreSyncPromise,
  clearBaseStoreSyncPromise,
  trackBaseStoreSync
};
